<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v">This one’s for you, Jessica. Thank you.<br/>And—always—Paul.</a></p><a id="page_v">
</a><p><a id="page_v"></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?82b1ac82